import * as React from 'react';
const GoogleIcon = () => (
  <svg width={38} height={38} viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x={0.5} y={0.5} width={37} height={37} rx={7.5} fill="white" stroke="#4285F4" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.64 19.2042C27.64 18.566 27.5827 17.9524 27.4764 17.3633H19V20.8446H23.8436C23.635 21.9696 23.0009 22.9228 22.0477 23.561V25.8192H24.9564C26.6582 24.2524 27.64 21.9451 27.64 19.2042Z"
      fill="#4285F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 28.0009C21.43 28.0009 23.4673 27.195 24.9564 25.8205L22.0477 23.5623C21.2418 24.1023 20.2109 24.4214 19 24.4214C16.6559 24.4214 14.6718 22.8382 13.9641 20.7109H10.9573V23.0428C12.4382 25.9841 15.4818 28.0009 19 28.0009Z"
      fill="#34A853"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9641 20.7108C13.7841 20.1708 13.6818 19.594 13.6818 19.0008C13.6818 18.4076 13.7841 17.8308 13.9641 17.2908V14.959H10.9573C10.3477 16.174 10 17.5485 10 19.0008C10 20.4531 10.3477 21.8276 10.9573 23.0426L13.9641 20.7108Z"
      fill="#FBBC05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 13.5795C20.3214 13.5795 21.5077 14.0336 22.4405 14.9255L25.0218 12.3441C23.4632 10.8918 21.4259 10 19 10C15.4818 10 12.4382 12.0168 10.9573 14.9582L13.9641 17.29C14.6718 15.1627 16.6559 13.5795 19 13.5795Z"
      fill="#EA4335"
    />
  </svg>
);
export default GoogleIcon;
